<template>
  <div class="flex flex-row justify-center">
    <div class="spinner text-3xl" />
  </div>
</template>
<script>
export default {
}
</script>
